import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { IonContent, PopoverController } from '@ionic/angular';
import { MatStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SearchpopoverComponent } from 'src/app/shared/components/searchpopover/searchpopover.component';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';
import { MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { DatePipe } from '@angular/common';

// import { elementsFromPoint } from '@siemens/ngx-datatable/release/utils';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY HH:mm',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-quickscan-fill',
  templateUrl: './quickscan-fill.page.html',
  styleUrls: ['./quickscan-fill.page.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
  ],
})
export class QuickscanFillPage implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  @ViewChild('f', { read: NgForm }) form: any;
  submitted: boolean = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  selectedIndex: number = 0;
  stepChanged: boolean = false;
  questionAnswer: any = {}
  showView: boolean = false;
  questionList: any = [];
  sectionId: string = '';
  spinner: boolean = false;
  optionalTest: any = [];
  endSectionValue: boolean;
  enableButton: boolean;
  eliminatedSelection:any;
  quickScanForm: NgForm = null;
  optionalList: any = [];

  isLinear: boolean = false

  jumpIndex: number

  isSectionSkiped: boolean = false

  isOptional: boolean = true

  isCurrentSave: boolean = false;
  lastSaveData: any = {}
  lastQuestion: any = {}
  isSaveBack: boolean = false

  quickscans: any = []
  sectionList: any = []
  changedQuestions: any = [];
  buttonSection: any = [];
  buttonDisability: boolean;
  quickScanName: any;
  followUpDetector:any;
  followSkipSection:any;


  constructor(private _formBuilder: FormBuilder, private datePipe: DatePipe, private elementRef: ElementRef, private _translationService: TranslationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private formBuilder: FormBuilder, public _commonService: CommonService, private popoverController: PopoverController, public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
  }

  // ngAfterViewChecked() {
  //   this._commonService.changeRadioStyle()
  // }

  ionViewWillEnter() {
    this.isCurrentSave = false
    this.lastQuestion = {};
    this.lastSaveData = {}
    this.isSectionSkiped = false;
    this.endSectionValue = false;
    this.enableButton = false
    if (sessionStorage.path == "startpage") {
      this.quickscans = JSON.parse(sessionStorage.quickScanSection);
      this.quickScanName = sessionStorage.QuickScanName;
      sessionStorage.path = "end";
      this.sectionId = ''
      this.getQuickScanSectionList();
    } else {
      this.gotoQuickScan();
    }


  }


  async gotoQuickScan() {
    try {
      this._commonService.presentLoading()
      let data = {
        QuickScanId: sessionStorage.QuickScanId?sessionStorage.QuickScanId:''
      }
      let res = await this._apiService.startQuickScan(data, this._commonService.tempQuickScan)
      if (res) {
        sessionStorage.quickScanSection = JSON.stringify(res.QuickScanSection);

        sessionStorage.QuickScanFormId = res.QuickScanFormId
        sessionStorage.QuickScanId = res.QuickScanId;
        sessionStorage.QuickScanName = res.QuickScanName
        this.quickScanName = sessionStorage.QuickScanName;
        this.quickscans = JSON.parse(sessionStorage.quickScanSection);
        this.sectionId = ''
        this.getQuickScanSectionList();
        this._commonService.dismiss();

      }


    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }

  get filterOptional() {
    return this.quickscans[0].QuickScanQuestions.filter(question => !question.hidden && (!question.IsOptional || (question.IsOptional && (question.dependQuestion && question.dependQuestion.length) > 0)));
  }

  get filterSelectionList() {
    return this.sectionList.filter(x => x.optional != true && x.display == true);
  }


  // ionViewDidEnter(){
  //   this.getQuickScanSectionList()
  // }

  ionViewDidLeave() {
    this.showView = false;
    this._commonService.displayRadio = false;
    sessionStorage.quickScanSection = JSON.stringify(this.quickscans);
  }

  onStepClick(event) {

    this.updateStepper(this.selectedIndex);


  }

  async onStepChange(event, stepper: MatStepper) {

    this.selectedIndex = event.selectedIndex;

    // this.updateStepper(this.selectedIndex);
    this.enableButton = false;

    if (event.previouslySelectedIndex == 0 && event.selectedIndex == 1) {
      this.onStepClick(event);
    }




  }

  goBack() {
    this.router.navigate(['quickscan'], { replaceUrl: true });
  }

  async goTop() {


    if (this.content) {
      this.content.getScrollElement().then(el => {
        if (el) {
          this.content.scrollToPoint(0, 0, 0);
        }
      });
    }


  }

  async endQuickScan() {
    //if(this.stepper.selectedIndex == (this.sectionList.length -1 )){
    try {
      this._commonService.presentLoading()
      let res = await this._apiService.endQuickScan('', sessionStorage.QuickScanFormId)

      this._commonService.dismiss()
      this.router.navigate(['quickscan/result'], { replaceUrl: true })
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

    //}
  }
  ionViewWillLeave() {
    // this._commonService.changeRadioStyle();
  }
async OnMultiplechangeValue(event,question,answerId){
  if(event.detail.checked==true){
    if(question.SelectedAnswerId){
      if(!question.SelectedAnswerId.includes(answerId)){
        question.SelectedAnswerId.push(answerId);
      }
      question.Testcase = answerId;
    }else{
      question.SelectedAnswerId=[];
      question.SelectedAnswerId.push(answerId);
      question.Testcase = answerId;
    }

  }else{
    if(question.SelectedAnswerId)
      {      if(question.SelectedAnswerId.includes(answerId)){
      for( var i = 0; i < question.SelectedAnswerId.length; i++)
      { if ( question.SelectedAnswerId[i] === answerId)
        { question.SelectedAnswerId.splice(i, 1);
        }
      }
      this.eliminatedSelection = answerId;
      let k= question.QuickScanAnswer.find(x=>x.QuickScanAnswerId == answerId);
      if(k){
        if(k.FollowQuickScanQuestion){
          if(k.FollowQuickScanQuestion.length>0){
            k.FollowQuickScanQuestion.forEach(async x=>{
              x.AnswerValue = null;
              await this.deleteFollowUoQuickscanQuestion(x,question);
            })
          }
        }
        if(k.FollowUpQuestionId){
          if(k.FollowUpQuestionId.length>0){
            let pushData:any = [];
            for (let a = 0; a < question.SelectedAnswerId.length; a++) {
              let b = question.QuickScanAnswer.find(q => q.QuickScanAnswerId == question.SelectedAnswerId[a]);
              if (b && b.FollowUpQuestionId) {
                if (b.FollowUpQuestionId.length > 0) {
                  b.FollowUpQuestionId.forEach(z => {
                    pushData.push(z);
                  })
                }
              }
            }
            k.FollowUpQuestionId.forEach(async x=>{

              if(!pushData.includes(x))
              await this.testCase(x,k.QuickScanQuestionId);
            })
          }
        }
      }
      question.Testcase = '';

    }}
  }

  question.showLoading = true;

  if (question.DataType != "DataType_Textbox" || (question.DataType == "DataType_Textbox" && question.AnswerValue)) {
    let selectedAnswer = question.QuickScanAnswer.find(x => x.QuickScanAnswerId == question.Testcase);
    if(selectedAnswer && selectedAnswer.FollowQuickScanQuestion && selectedAnswer.FollowQuickScanQuestion.length > 0) {
      question.FollowQuickScanQuestion = [];
      question.FollowQuickScanQuestion.push(selectedAnswer.FollowQuickScanQuestion[0]);
    } else {
      if(question.SelectedAnswerId){
        if(question.SelectedAnswerId.length>0){
          let count = 0;
          let w = question.QuickScanAnswer.filter(x=>x.FollowQuickScanQuestion.length>0);
          question.SelectedAnswerId.forEach(y=>{
            if(w.find(q=>q.QuickScanAnswerId==y)){
              count++;
            }
          });
          if(!(count>0)){
            question.FollowQuickScanQuestion = [];
          }
        }else{
          question.FollowQuickScanQuestion = [];
        }
      }else{
        question.FollowQuickScanQuestion = [];
      }

    }
    if (this.changedQuestions.length > 0) {
      if (this.changedQuestions.find(x => x.QuickScanQuestionId == question.QuickScanQuestionId).length == 0) {
        this.changedQuestions.push(question);
      }
    } else {
      this.changedQuestions.push(question);
    }
  }
  this.saveQuickScanquestions(false);
}

testCase(id,questionId){
  let k = this.quickscans[0].QuickScanQuestions.find(k=>k.QuickScanQuestionId==id);
  if(k){
    k.hidden = true;
    k.IsOptional = true;
    k.SelectedAnswerId=null;

    let data = {
      QuickScanQuestionId: k.QuickScanQuestionId ? k.QuickScanQuestionId : null,
      SelectedAnswerId: null,
      AnswerValue: null
    }

    k.dependQuestion = [...k.dependQuestion.filter(f => f != questionId)];
    if(k.SkipSection == true){
      this.followSkipSection = k.SkipSectionId
    }
    k.SkipSection = false;
    if(k.isPostCompleted == true){
      k.isPostCompleted = false;
    }
    this.postFollowUpData(data,k);
    if(k.followUpId){
      k.followUpId.forEach(async t=>{
        this.testCase(t,k.QuickScanQuestionId);
      })
    }
  }

}
prechangeValue(event, question){
  this.followUpDetector = question.SelectedAnswerId;
}

  async OnchangeValue(event, question) {

    let w = question.QuickScanAnswer.filter(x=>x.FollowQuickScanQuestion.length>0);
    if(this.followUpDetector){
      if(w){
        if(w.length>0){
          w.forEach(g=>{
            if(event!=this.followUpDetector && g.QuickScanAnswerId==this.followUpDetector ){
              g.FollowQuickScanQuestion.forEach(async x=>{
                x.AnswerValue = null;
                await this.deleteFollowUoQuickscanQuestion(x,question);
              })

            }
          })
        }else{}
      }
    }else{
      if(w){
        if(w.length>0){
          w.forEach(g=>{
            if(g.QuickScanAnswerId!=question.SelectedAnswerId ){
              g.FollowQuickScanQuestion.forEach(async x=>{
                x.AnswerValue = null;
                await this.deleteFollowUoQuickscanQuestion(x,question);
              })

            }
          })
        }
      }
    }

    if(this.followUpDetector){
      let w = question.QuickScanAnswer.find(x=>x.QuickScanAnswerId==this.followUpDetector);
      if(w){
        if(w){
          if(w.FollowUpQuestionId){
            if(w.FollowUpQuestionId.length>0){
              w.FollowUpQuestionId.forEach(async x=>{
                await this.testCase(x,w.QuickScanQuestionId);
              })
            }
          }
        }
      }
    }
    question.SelectedAnswerId = event;
    question.showLoading = true;
    // this.followUpDetector = question.SelectedAnswerId;

    // console.log("The final andfirst",this.questionList)
    // this.sectionList.forEach(element => {
    //     if(element.QuickScanSectionId!=question.SelectedAnswerId){
    //       let k = this.questionList.filter(y=>y.QuickScanSectionId==element.QuickScanSectionId)
    //       if(k[0].isHidden=="1" && element.isHidden=="0"){
    //         element.isHidden="1";
    //       }
    //     }

    // });//

    if ((question.DataType != "DataType_Textbox" && question.DataType != 'DataType_TextField') || ((question.DataType == "DataType_Textbox" && question.AnswerValue) || (question.DataType == "DataType_TextField" && question.AnswerValue))) {
      let selectedAnswer = question.QuickScanAnswer.find(x => x.QuickScanAnswerId == event);
      if(selectedAnswer && selectedAnswer.FollowQuickScanQuestion && selectedAnswer.FollowQuickScanQuestion.length > 0) {
        question.FollowQuickScanQuestion = [];
        question.FollowQuickScanQuestion.push(selectedAnswer.FollowQuickScanQuestion[0]);
      } else {
        question.FollowQuickScanQuestion = [];
      }
      if (this.changedQuestions.length > 0) {
        if (this.changedQuestions.find(x => x.QuickScanQuestionId == question.QuickScanQuestionId).length == 0) {
          this.changedQuestions.push(question);
        }
      } else {
        this.changedQuestions.push(question);
      }
    }
    this.saveQuickScanquestions(false);
  }

  onInputChange(question) {



    let index = this.filterOptional.findIndex((item, index) => { return item.QuickScanQuestionId == question.QuickScanQuestionId });
    if (index == this.filterOptional.length - 1) {
      this.enableButton = true;
    }

  }

  async getQuickScanSectionList() {
    try {
      this._commonService.presentLoading();
      let quickScanId = sessionStorage.QuickScanId
      let res = await this._apiService.getQuickScanSectionList(quickScanId);
      sessionStorage.SectionList = JSON.stringify(res.body);
      this.optionalList = [...res.body];
      for(let i = 0; i< this.optionalList.length;i++) {
        this.optionalList[i].SortOrder = i+1;
      }
      this.sectionList = this.optionalList.filter(x => x.isHidden == "0");

      let obj = JSON.stringify(res.body);
      this.sectionList.forEach(element => {
        if (element.isHidden == "0")
          element.completed = false;
        element.optional = false;
      });


      let k = this.quickscans[0].QuickScanQuestions.filter(x => x.SkipSectionId != null)
      if (k.length != 0) {
        this.optionalList.forEach(element => {
          if (element.QuickScanSectionId == k[0].SkipSectionId) {
            element.isHidden = "0";
          }

        });
        let j = this.optionalList.indexOf(this.optionalList.filter(x => x.QuickScanSectionId == k[0].SkipSectionId)[0])
        for (let p = (j - 1); p >= 0; p--) {
          if (this.optionalList[p].isHidden == "0") {
            let t = this.sectionList.indexOf(this.sectionList.filter(x => x.QuickScanSectionId == this.optionalList[p].QuickScanSectionId)[0]);
            if (!this.sectionList.includes(this.optionalList.filter(x => x.QuickScanSectionId == k[0].SkipSectionId)[0])) {
              this.sectionList.splice(t + 1, 0, this.optionalList.filter(x => x.QuickScanSectionId == k[0].SkipSectionId)[0]);
            }
            break;
          }
        }
      }



      let index = 0;
      for (var i = 0; i < this.sectionList.length; i++) {
        let hiddenFlag = false;
        if (!this.sectionList[i].optional) {
          if (i == 0) {
            this.quickscans[0].QuickScanQuestions.forEach(element => {
              element.hidden = hiddenFlag;
              if (element.SkipSection) {
                hiddenFlag = true;
              }
            });

            let unanswerdQuestion = this.quickscans[0].QuickScanQuestions.filter(x => x.IsOptional == false && x.AnswerValue == null && x.SelectedAnswerId == null && x.hidden == false);
            if(this.sectionList.length==1){
              this.endSectionValue = true;
            }else{
              this.endSectionValue = false;
            }
            if (unanswerdQuestion.length == 0) {
              this.sectionList[i].completed = true;
              index = 0;
              this.renderQuickScanQuestions(true);
            } else {
              index = 0;
              this.renderQuickScanQuestions(true);
              break;
            }
          } else {
            try {
              let res = await this._apiService.getNextSection(this.sectionList[i].QuickScanSectionId, sessionStorage.QuickScanFormId);
              this.quickscans = res.body.QuickScanSection;
              let k = this.sectionList.indexOf(this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0]);
              this.sectionList[k].optional = false;
              for (let p = (k - 1); p >= 0; p--) {
                if (this.optionalList[p].isHidden == "0") {
                  let t = this.sectionList.indexOf(this.sectionList.filter(x => x.QuickScanSectionId == this.optionalList[p].QuickScanSectionId)[0]);
                  if (!this.sectionList.includes(this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0])) {
                    this.sectionList.splice(t + 1, 0, this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0]);
                  }
                  break;
                }
              }
              hiddenFlag = false;
              this.quickscans[0].QuickScanQuestions.forEach(element => {
                element.hidden = hiddenFlag;
                if (element.SkipSection) {
                  hiddenFlag = true;
                }
              });
              let w = this.quickscans[0].QuickScanQuestions.filter(x => x.SelectedAnswerId != null);
              if (w.length > 0) {
                w.forEach(z => {
                  if(z.DataType == "DataType_MultiSelect"){
                    z.SelectedAnswerId.forEach(y =>{
                      let q = z.QuickScanAnswer.find(e=>e.QuickScanAnswerId == y);
                      if(q.FollowUpQuestionId){
                        if(q.FollowUpQuestionId.length > 0){
                          this.quickscans[0].QuickScanQuestions.forEach(element => {
                            q.FollowUpQuestionId.forEach(v => {
                              if (element.QuickScanQuestionId == v) {
                                element.IsOptional = false;
                              }
                            });
                          });
                        }
                      }

                    })

                  }else{
                    if (z.FollowUpQuestionId.length > 0) {
                      this.quickscans[0].QuickScanQuestions.forEach(element => {
                        z.FollowUpQuestionId.forEach(x => {
                          if (element.QuickScanQuestionId == x) {
                            element.IsOptional = false;
                          }
                        });
                      });
                    }
                  }

                })

              }
              let unanswerdQuestion = this.quickscans[0].QuickScanQuestions.filter(x => x.IsOptional == false && x.AnswerValue == null && x.SelectedAnswerId == null && x.hidden == false);
              if (!this.sectionList[i].optional) {
                index = index + 1;
              }
              if(k+1 == this.sectionList.length){
                this.endSectionValue = true;
              }else{
                this.endSectionValue = false;
              }
              if (unanswerdQuestion.length == 0) {
                this.sectionList[i].completed = true;
                this.renderQuickScanQuestions(true);
              } else {
                this.renderQuickScanQuestions(true);
                break;
              }
            } catch (error) {

            }
          }
        }
      }
      // this.sectionList.forEach(element => {
      //   if (element.completed == true) {
      //     element.optional = false;
      //   }
      // });
      this.sectionList.forEach(x => {
        x.display = false;
      });



      let visibleSteps = this.sectionList.filter(x => !x.optional);
      let newIndex = visibleSteps.findIndex((item, index) => { return item.QuickScanSectionId == this.quickscans[0].QuickScanSectionId });
      this.sectionList[0].display = true;
      this.sectionList[this.sectionList.length - 1].display = true;
      visibleSteps[newIndex].display = true;
      if (newIndex == 0) {
        visibleSteps[newIndex + 1]?visibleSteps[newIndex + 1].display = true:'';
        visibleSteps[newIndex + 2]?visibleSteps[newIndex + 2].display = true:'';
      }
      if (newIndex != 1 && newIndex != 0) {
        visibleSteps[newIndex - 1].display = true;
        visibleSteps[newIndex - 2].display = true;
      }

      if (!(newIndex + 1 >= visibleSteps.length)) {
        visibleSteps[newIndex + 1].display = true;
      }

      if (!(newIndex + 2 >= visibleSteps.length)) {
        visibleSteps[newIndex + 2].display = true;
      }

      this.sectionList.forEach(element => {
        visibleSteps.forEach(x => {
          if (element.QuickScanSectionId == x.QuickScanSectionId && x.display == true) {
            element.display = true;
          }
        })
      })

      let arraySkip = this.sectionList.filter(x => x.display == true);
      let skipIndex = arraySkip.findIndex((item, index) => { return item.QuickScanSectionId == visibleSteps[newIndex].QuickScanSectionId })

      this._commonService.dismiss();
      this.showView = true;
      if (newIndex != 0) {
        setTimeout(() => {
          this.stepper.selectedIndex = skipIndex;
        }, 500);

      }

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  showHelpText(question) {

  }

  async presentSearchPopover(event: any, question) {
    const popover = await this.popoverController.create({
      component: SearchpopoverComponent,
      event: event,
      componentProps: { value: question },
      translucent: false,
      mode: 'ios',
      cssClass: 'searchPopOver'
    });
    return await popover.present();
  }



  async getQuickScanQuestions(id, flag) {
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.getNextSection(id, sessionStorage.QuickScanFormId)
      if (res) {
        this.stepChanged = true;
        this.content.scrollToTop();
        this.submitted = false;

        this.quickscans = res.body.QuickScanSection
        // let k = this.optionalList.indexOf(this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0])
        // for (let p = (k - 1); p >= 0; p--) {
        //   if (this.optionalList[p].isHidden == "0") {
        //     let t = this.sectionList.indexOf(this.sectionList.filter(x => x.QuickScanSectionId == this.optionalList[p].QuickScanSectionId)[0]);
        //     if (!this.sectionList.includes(this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0])) {
        //       this.sectionList.splice(t + 1, 0, this.optionalList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0]);
        //     }
        //     break;
        //   }
        // }
      }
      this.renderQuickScanQuestions(flag);
      this.isSectionSkiped = true;
      this._commonService.dismiss()
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  renderQuickScanQuestions(flag) {
    let hiddenFlag = false;
    let skipSectionId = '';
    this.quickscans.forEach(element => {
      element.QuickScanQuestions.forEach(elem => {
        elem.hidden = hiddenFlag;
        if (!elem.dependQuestion) {
          elem.dependQuestion = []
        }
        if (!elem.followUpId) {
          elem.followUpId = []
        }
        if (elem.FollowUpQuestionId.length > 0) {
          elem.FollowUpQuestionId.forEach(ele => {

            let obj = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == ele)
            if (obj) {
              if (obj.dependQuestion) {
                if (!obj.dependQuestion.includes(elem.QuickScanQuestionId)) {
                  elem.followUpId.push(ele)
                  obj.dependQuestion.push(elem.QuickScanQuestionId)
                }
              } else {
                obj.dependQuestion = []
                if (!obj.dependQuestion.includes(elem.QuickScanQuestionId)) {
                  elem.followUpId.push(ele)
                  obj.dependQuestion.push(elem.QuickScanQuestionId)
                }
              }
            }
          });

        }

        if (!Array.isArray(elem.SelectedAnswerId) && elem.SelectedAnswerId || elem.AnswerValue) {
          elem.isPostCompleted = true;
          let obj = elem.QuickScanAnswer.find(x => elem.SelectedAnswerId == x.QuickScanAnswerId)
          if (obj) {
            if (obj && obj.FollowUpQuestionId) {
              if (obj.FollowUpQuestionId.length > 0) {
                element.QuickScanQuestions.forEach(x => {
                  obj.FollowUpQuestionId.forEach(y => {
                    if (x.QuickScanQuestionId == y) {
                      x.IsOptional = false;
                    }
                  });
                });
              }
            }

            elem.FollowQuickScanQuestion = [];
            if(obj.FollowQuickScanQuestion.length > 0) {
              elem.FollowQuickScanQuestion.push(obj.FollowQuickScanQuestion[0]);
              if(obj.FollowQuickScanQuestion[0].AnswerValue==null){
                elem.isPostCompleted = false;
              }
            }
          }

        }
        else if (Array.isArray(elem.SelectedAnswerId)) {
          elem.isPostCompleted = true;
          elem.FollowQuickScanQuestion = [];
          if (elem.SelectedAnswerId.length > 0) {
            for (let w = 0; w < elem.SelectedAnswerId.length; w++) {
              let obj = elem.QuickScanAnswer.find(x => elem.SelectedAnswerId[w] == x.QuickScanAnswerId);
              if (obj) {
                if (obj.FollowUpQuestionId) {
                  if (obj.FollowUpQuestionId.length > 0) {
                    element.QuickScanQuestions.forEach(x => {
                      obj.FollowUpQuestionId.forEach(y => {
                        if (x.QuickScanQuestionId == y) {
                          x.IsOptional = false;
                        }
                      });
                    });
                  }
                }else{
                  obj.FollowUpQuestionId = [];
                  if (obj.FollowUpQuestionId.length > 0) {
                    element.QuickScanQuestions.forEach(x => {
                      obj.FollowUpQuestionId.forEach(y => {
                        if (x.QuickScanQuestionId == y) {
                          x.IsOptional = false;
                        }
                      });
                    });
                  }
                }

                if (obj.SkipSection) {
                  elem.SkipSection = obj.SkipSection;
                  elem.SkipSectionId = obj.SkipSectionId
                }

                if (obj.FollowQuickScanQuestion.length > 0) {
                  elem.FollowQuickScanQuestion.push(obj.FollowQuickScanQuestion[0]);
                  if(obj.FollowQuickScanQuestion[0].AnswerValue==null){
                    elem.isPostCompleted = false;
                  }

                }


                if (obj.FollowUpQuestionId.length > 0) {
                  for (let k = 0; k < obj.FollowUpQuestionId.length; k++) {
                    if (!elem.followUpId.includes(obj.FollowUpQuestionId[k])) {
                      elem.followUpId.push(obj.FollowUpQuestionId[k]);
                      // if(!elem.FollowUpQuestionId.includes(obj.FollowUpQuestionId[k])){
                      //   elem.FollowUpQuestionId.push(obj.FollowUpQuestionId[k])
                      // }
                      let ob = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == obj.FollowUpQuestionId[k]);
                      if (ob) {
                        if (ob.dependQuestion) {
                          if (!ob.dependQuestion.includes(elem.QuickScanQuestionId)) { ob.dependQuestion.push(elem.QuickScanQuestionId); }
                        } else {
                          ob.dependQuestion = [];
                          if (!ob.dependQuestion.includes(elem.QuickScanQuestionId)) { ob.dependQuestion.push(elem.QuickScanQuestionId); }
                        }

                      }

                    }
                  }

                }
              }
            }

          }

        } else {
          elem.isPostCompleted = false
        }

        if (elem.SkipSection) {
          hiddenFlag = true;
          skipSectionId = elem.SkipSectionId;
          let index = this.quickscans[0].QuickScanQuestions.findIndex((item, i) => {
            return item.QuickScanQuestionId === elem.QuickScanQuestionId
          });
          let quickScanQuestions = this.quickscans[0].QuickScanQuestions;
          for (var i = index + 1; i < quickScanQuestions.length; i++) {
            quickScanQuestions[i].hidden = true;
          }
          let initial = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == this.quickscans[0].QuickScanSectionId });
          let q = JSON.parse(sessionStorage.SectionList);
          let p = q.filter(x => x.isHidden == "1");
          p.forEach(x => {
            if (skipSectionId != x.QuickScanSectionId) {
              if (this.sectionList.includes(this.sectionList.filter(n => n.QuickScanSectionId == x.QuickScanSectionId)[0])) {
                let i = this.sectionList.indexOf(this.sectionList.filter(n => n.QuickScanSectionId == x.QuickScanSectionId)[0]);
                if(i>initial && i == initial+1){
                  this.sectionList[i].isHidden = "1";
                  this.sectionList[i].completed = true;
                  this.sectionList[i].optional = true;
                  this.sectionList.splice(i, 1)

                }

              }
            }
          })
          let final = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == skipSectionId });
          if (final == -1) {
            this.optionalList.forEach(element => {
              if (element.QuickScanSectionId == skipSectionId && element.isHidden == "1") {
                element.isHidden = "0";
                element.completed = false;
                element.optional = false;




              }
            });
          }
          let k = this.optionalList.indexOf(this.optionalList.filter(x => x.QuickScanSectionId == skipSectionId)[0])
          for (let p = (k - 1); p >= 0; p--) {
            if (this.optionalList[p].isHidden == "0") {
              let t = this.sectionList.indexOf(this.sectionList.filter(x => x.QuickScanSectionId == this.optionalList[p].QuickScanSectionId)[0]);
              if (!this.sectionList.includes(this.optionalList.filter(x => x.QuickScanSectionId == skipSectionId)[0])) {
                this.sectionList.splice(t + 1, 0, this.optionalList.filter(x => x.QuickScanSectionId == skipSectionId)[0]);
              }
              break;
            }
          }
          let w = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == skipSectionId });
          for (let j = initial + 1; j < w; j++) {
            this.sectionList[j].optional = true;
          }
          this.sectionList[w].optional = false;
          let sectionStorage = JSON.parse(sessionStorage.SectionList);
          for(let j=k+1;j<this.optionalList.length;j++){
            if(sectionStorage[j].isHidden=="0"){
              let hide = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == sectionStorage[j].QuickScanSectionId });
              this.sectionList[w].optional=false;
              for(let t = w+1;t<hide;t++){
               {
                  this.sectionList[t].optional=true;
                }
              }
              break;
            }
          }
          let initialIndex = this.sectionList.findIndex((item, i) => {
            return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
          });
          let finalIndex = this.sectionList.findIndex((item, i) => {
            return item.QuickScanSectionId === skipSectionId
          });
          for (var j = initialIndex + 1; j < finalIndex; j++) {
            this.sectionList[j].optional = true;
          }
          let z = this.sectionList.filter(x => x.optional != true);
          this.sectionList.forEach(x=>{
            x.display=false;
          })
          let initialIndex1 = z.findIndex((item, i) => {
            return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
          });
          let finalIndex2 = z.findIndex((item, i) => {
            return item.QuickScanSectionId === skipSectionId
          });
          this.sectionList[0].display = true;
          this.sectionList[this.sectionList.length - 1].display = true;
          z[initialIndex1].display = true;
          if (initialIndex1 != 1 && initialIndex1 != 0) {

            z[initialIndex1 - 1].display = true;
            z[initialIndex1 - 2].display = true;
          }

            if (!(initialIndex1 + 1 >= z.length)) {
              z[initialIndex1 + 1].display = true;
            }
            if (!(initialIndex1 + 2 >= z.length)) {
              z[initialIndex1 + 2].display = true;
            }
            this.sectionList.forEach(element => {
              z.forEach(x => {
                if (element.QuickScanSectionId == x.QuickScanSectionId && x.display == true) {
                  element.display = true;
                }
              })
            })

        }
      });
      //set segment completed
      let unanswerdQuestion = this.quickscans[0].QuickScanQuestions.filter(x => x.isPostCompleted == false && x.IsOptional == false && x.hidden == false);
      if (unanswerdQuestion.length == 0) {
        this.sectionList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0].completed = true;
      }


      // if(hiddenFlag && flag) {
      //   setTimeout(() => {
      //     this.skipSection(skipSectionId);
      //   }, 10);
      // }
    });
  }

  save() {
    if (this.changedQuestions.length > 0) {
      this.saveQuickScanquestions(false);
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    } else {
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    }
  }

  async postFormData(data, question) {
    try {
      let res = await this._apiService.postFillQuickScan(data, sessionStorage.QuickScanFormId);
      question.showLoading = false;
      // sessionStorage.quickScanSection = JSON.stringify(this.quickscans);
    }
    catch (error) {
      question.showLoading = false;
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async saveQuickScanquestions(goBack) {
    if (this.changedQuestions.length > 0) {
      // this._commonService.presentLoading();
      this.spinner = true;
      let skipSection = false;
      for (var k = 0; k < this.changedQuestions.length; k++) {
        let singleQuestion = this.changedQuestions[k];

        try {
          let data = {
            QuickScanQuestionId: singleQuestion.QuickScanQuestionId ? singleQuestion.QuickScanQuestionId : null,
            SelectedAnswerId: singleQuestion.SelectedAnswerId ? singleQuestion.SelectedAnswerId : null,
            AnswerValue: singleQuestion.AnswerValue ? singleQuestion.AnswerValue : null
          }
          if (singleQuestion.DataType == "DataType_Textbox" || singleQuestion.DataType == "DataType_Date" || singleQuestion.DataType == "DataType_TextField" ) {
            data.SelectedAnswerId = null;
          }

          this.changedQuestions.splice(k, 1);
          let question = this.quickscans[0].QuickScanQuestions.filter(x => x.QuickScanQuestionId == singleQuestion.QuickScanQuestionId)[0];
          this.postFormData(data, question);
          if (singleQuestion.DataType == "DataType_MultiSelect") {
            if(data.SelectedAnswerId == null || data.SelectedAnswerId.length==0){
              question.isPostCompleted = false;
            }else if(data.SelectedAnswerId){
                let count = 0;
                let e = question.QuickScanAnswer.filter(k=>k.FollowQuickScanQuestion.length>0);
                data.SelectedAnswerId.forEach(o=>{
                  if(e.find(f=>f.QuickScanAnswerId==o)){
                    count++;
                  }
                });
                if(!(count>0)){

                  question.isPostCompleted = true;
                }else{
                  question.isPostCompleted = false;
                }

            }
            else{
              question.isPostCompleted = true;
            }
          }else{
            let selectedAnswer = question.QuickScanAnswer.find(x => x.QuickScanAnswerId == question.SelectedAnswerId);
            if(selectedAnswer && selectedAnswer.FollowQuickScanQuestion && selectedAnswer.FollowQuickScanQuestion.length > 0) {
              question.isPostCompleted = false;
            } else {
              question.isPostCompleted = true;
            }
          }

          let testAnswer = question.QuickScanAnswer.filter(x => x.QuickScanAnswerId == ((singleQuestion.DataType == "DataType_MultiSelect")?singleQuestion.Testcase:singleQuestion.SelectedAnswerId))
          let previousQuestion = JSON.stringify(question);
          if (testAnswer.length == 0) {
            testAnswer[0] = question;
            if (this.quickscans[0].QuickScanSectionId == this.sectionList[0].QuickScanSectionId) {
              this.optionalTest = testAnswer[0];
            }

          } else {
            if (this.quickscans[0].QuickScanSectionId == this.sectionList[0].QuickScanSectionId) {
              this.optionalTest = testAnswer[0];
            }
          }
          question.SkipSection = testAnswer[0].SkipSection;
          question.SkipSectionId = testAnswer[0].SkipSectionId;
          skipSection = testAnswer[0].SkipSection;

          this.isCurrentSave = true;
          this.lastSaveData = data;
          this.lastQuestion = question;

          if (!testAnswer[0].SkipSection) {
            if (testAnswer[0].FollowUpQuestionId && singleQuestion.DataType != "DataType_MultiSelect") {
              if (question.followUpId.length > 0) {
                question.followUpId.forEach(elem => {
                  let objs = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == elem)
                  if (objs) {
                    objs.dependQuestion = [...objs.dependQuestion.filter(f => f != question.QuickScanQuestionId)]
                    objs.IsOptional = true;
                  }
                });
              }
              testAnswer[0].FollowUpQuestionId.forEach(element => {
                let obj = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == element)
                if (obj) {
                  obj.SelectedAnswerId = '';
                  obj.isPostCompleted = false;
                  if (!obj.dependQuestion.includes(question.QuickScanQuestionId)) {
                    if (!question.followUpId.includes(element)) {
                      question.followUpId.push(element)
                    }
                    obj.dependQuestion.push(question.QuickScanQuestionId);
                    obj.IsOptional = false;
                  }
                }
              });
            } else if(question.followUpId.length > 0 && singleQuestion.DataType != "DataType_MultiSelect") {


                question.followUpId.forEach(element => {

                  let obj = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == element)
                  if (obj) {
                    obj.dependQuestion = [...obj.dependQuestion.filter(f => f != question.QuickScanQuestionId)]
                    question.followUpId = [...question.followUpId.filter(f => f != obj.QuickScanQuestionId)]
                    obj.IsOptional = true;
                  }
                });

            }else if(testAnswer[0].FollowUpQuestionId && singleQuestion.DataType == "DataType_MultiSelect"){
              let otherFollowUps:any = [];
              for(let a=0;a<singleQuestion.SelectedAnswerId.length;a++){
                let b = question.QuickScanAnswer.find(q=>q.QuickScanAnswerId == singleQuestion.SelectedAnswerId[a]);
                if(b && b.FollowUpQuestionId){
                 if(b.FollowUpQuestionId.length>0){
                   b.FollowUpQuestionId.forEach(x=>{
                     otherFollowUps.push(x);
                   })
                 }
                }
              }
              if (question.followUpId.length > 0) {
                let k = question.QuickScanAnswer.find(q=>q.QuickScanAnswerId == this.eliminatedSelection);
                if(k && k.FollowUpQuestionId){
                  if(k.FollowUpQuestionId.length>0)
                 { k.FollowUpQuestionId.forEach(
                    x=>{
                      if(question.followUpId.includes(x) && !otherFollowUps.includes(x) ){
                        let objs = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == x)
                        if (objs) {
                          objs.dependQuestion = [...objs.dependQuestion.filter(f => f != question.QuickScanQuestionId)]
                          objs.IsOptional = true;
                        }
                      }
                    }
                  )}
                }
                this.eliminatedSelection = null;
                // question.followUpId.forEach(elem => {
                //   let objs = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == elem)
                //   if (objs) {
                //     objs.dependQuestion = [...objs.dependQuestion.filter(f => f != question.QuickScanQuestionId)]
                //     objs.IsOptional = true;
                //   }
                // });
              }
              testAnswer[0].FollowUpQuestionId.forEach(element => {
                let obj = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == element)
                if (obj) {
                  if (!obj.dependQuestion.includes(question.QuickScanQuestionId)) {
                    if (!question.followUpId.includes(element)) {
                      question.followUpId.push(element)
                    }
                    obj.dependQuestion.push(question.QuickScanQuestionId);
                    obj.IsOptional = false;
                  }
                }
              });
            }
            else if(question.followUpId.length > 0 && singleQuestion.DataType == "DataType_MultiSelect"){
              if(singleQuestion.SelectedAnswerId.length == 0){
                console.log("Hello");
              }

              // question.followUpId.forEach(element => {

              //   let obj = this.quickscans[0].QuickScanQuestions.find(q => q.QuickScanQuestionId == element)
              //   if (obj) {
              //     obj.dependQuestion = [...obj.dependQuestion.filter(f => f != question.QuickScanQuestionId)]
              //     question.followUpId = [...question.followUpId.filter(f => f != obj.QuickScanQuestionId)]
              //     obj.IsOptional = true;
              //   }
              // });
            }
            if (this.quickscans[0].QuickScanQuestions.filter(x => x.SkipSection == true).length == 0) {
              this.quickscans[0].QuickScanQuestions.forEach(element => {
                element.hidden = false;
              });

              let initialIndex = this.sectionList.findIndex((item, i) => {
                return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
              });

              let b = (this.followSkipSection!=null && this.followSkipSection!=undefined && this.followSkipSection!='' )?(this.followSkipSection):JSON.parse(previousQuestion).SkipSectionId;

              let finalIndex = this.sectionList.findIndex((item, i) => {
                return item.QuickScanSectionId === b;

              });

              this.followSkipSection = null;
              for (var j = initialIndex + 1; j < finalIndex; j++) {
                this.sectionList[j].optional = false;
                // this.sectionList[j].display = true;
              }

              if(finalIndex!=-1)
              {   let w = JSON.parse(sessionStorage.SectionList);
                 for(let k = finalIndex;k<this.sectionList.length;k++){

                     let x = w.find(x => x.QuickScanSectionId == this.sectionList[k].QuickScanSectionId);
                     if(x.isHidden == "1"){
                       this.sectionList[k].isHidden = "1";
                       this.sectionList[k].optional = true;
                     }

                 }}

                 this.sectionList = this.sectionList.filter(x=>x.isHidden != "1");


              let z = this.sectionList.filter(x => x.optional != true);

              this.sectionList.forEach(x=>{
                x.display=false;
              })

              let initialIndex1 = z.findIndex((item, i) => {
                return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
              });

              let finalIndex2 = z.findIndex((item, i) => {
                return item.QuickScanSectionId === JSON.parse(previousQuestion).SkipSectionId;
              });

              this.sectionList[0].display = true;
              this.sectionList[this.sectionList.length - 1].display = true;


              z[initialIndex1].display = true;
              if (initialIndex1 != 1 && initialIndex1 != 0) {

                z[initialIndex1 - 1].display = true;
                z[initialIndex1 - 2].display = true;
              }

              if (!(initialIndex1 + 1 >= z.length)) {
                z[initialIndex1 + 1].display = true;
              }

              if (!(initialIndex1 + 2 >= z.length)) {
                z[initialIndex1 + 2].display = true;
              }

              this.sectionList.forEach(element => {
                z.forEach(x => {
                  if (element.QuickScanSectionId == x.QuickScanSectionId && x.display == true) {
                    element.display = true;
                  }
                })
              })
              // this.sectionList.forEach(element => {
              //   element.optional = false;
              // });

              if (this.quickscans[0].QuickScanQuestions.filter(x => x.IsOptional == false && x.AnswerValue == null && x.SelectedAnswerId == null).length > 0) {
                this.sectionList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0].completed = false;
              }
            }
          } else {

            let index = this.quickscans[0].QuickScanQuestions.findIndex((item, i) => {
              return item.QuickScanQuestionId === question.QuickScanQuestionId
            });
            let quickScanQuestions = this.quickscans[0].QuickScanQuestions;
            for (var i = index + 1; i < quickScanQuestions.length; i++) {
              quickScanQuestions[i].hidden = true;
            }

            let initial = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == this.quickscans[0].QuickScanSectionId });
            let q = JSON.parse(sessionStorage.SectionList);
            let p = q.filter(x => x.isHidden == "1");


              p.forEach(x => {
                if ((testAnswer.length > 0 || testAnswer[0] != "") && testAnswer[0].SkipSectionId != x.QuickScanSectionId) {
                  if (this.sectionList.includes(this.sectionList.filter(n => n.QuickScanSectionId == x.QuickScanSectionId)[0])) {
                    let i = this.sectionList.indexOf(this.sectionList.filter(n => n.QuickScanSectionId == x.QuickScanSectionId)[0]);
                    if(i>initial && i == initial+1){
                      this.sectionList[i].isHidden = "1";
                      this.sectionList[i].completed = true;
                      this.sectionList[i].optional = true;
                      this.sectionList.splice(i, 1)

                    }

                  }
                }
              })


            let final = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == testAnswer[0].SkipSectionId });
            if (final == -1) {
              this.optionalList.forEach(element => {
                if (element.QuickScanSectionId == testAnswer[0].SkipSectionId && element.isHidden == "1") {
                  element.isHidden = "0";
                  element.completed = false;
                  element.optional = false;




                }
              });
              // this.sectionList.splice(initial+1, 0, this.optionalList.filter(x => x.QuickScanSectionId == testAnswer[0].SkipSectionId)[0]);

            }
            let k = this.optionalList.indexOf(this.optionalList.filter(x => x.QuickScanSectionId == testAnswer[0].SkipSectionId)[0])
            for (let p = (k - 1); p >= 0; p--) {
              if (this.optionalList[p].isHidden == "0") {
                let t = this.sectionList.indexOf(this.sectionList.filter(x => x.QuickScanSectionId == this.optionalList[p].QuickScanSectionId)[0]);
                if (!this.sectionList.includes(this.optionalList.filter(x => x.QuickScanSectionId == testAnswer[0].SkipSectionId)[0])) {
                  this.sectionList.splice(t + 1, 0, this.optionalList.filter(x => x.QuickScanSectionId == testAnswer[0].SkipSectionId)[0]);
                }
                break;
              }
            }
            let w = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == testAnswer[0].SkipSectionId });
            for (let j = initial + 1; j < w; j++) {
              this.sectionList[j].optional = true;
            }
            this.sectionList[w].optional = false;
            let sectionStorage = JSON.parse(sessionStorage.SectionList);
            for(let j=k+1;j<this.optionalList.length;j++){
              if(sectionStorage[j].isHidden=="0"){
                let hide = this.sectionList.findIndex((item, index) => { return item.QuickScanSectionId == sectionStorage[j].QuickScanSectionId });
                this.sectionList[w].optional=false;
                for(let t = w+1;t<hide;t++){
                 {
                    this.sectionList[t].optional=true;
                  }
                }
                break;
              }
            }



            let initialIndex = this.sectionList.findIndex((item, i) => {
              return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
            });

            let finalIndex = this.sectionList.findIndex((item, i) => {
              return item.QuickScanSectionId === testAnswer[0].SkipSectionId
            });

            // this.sectionList.forEach(element => {
            //   if(element.completed == true)
            //   {element.optional = false;}
            // });

            // this.sectionList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0].completed = true;
            for (var j = initialIndex + 1; j < finalIndex; j++) {
              this.sectionList[j].optional = true;
            }

            let z = this.sectionList.filter(x => x.optional != true);

            this.sectionList.forEach(x=>{
              x.display=false;
            })

            let initialIndex1 = z.findIndex((item, i) => {
              return item.QuickScanSectionId === this.quickscans[0].QuickScanSectionId
            });

            let finalIndex2 = z.findIndex((item, i) => {
              return item.QuickScanSectionId === testAnswer[0].SkipSectionId
            });

            this.sectionList[0].display = true;
            this.sectionList[this.sectionList.length - 1].display = true;


            z[initialIndex1].display = true;
            if (initialIndex1 != 1 && initialIndex1 != 0) {

              z[initialIndex1 - 1].display = true;
              z[initialIndex1 - 2].display = true;
            }

            if (!(initialIndex1 + 1 >= z.length)) {
              z[initialIndex1 + 1].display = true;
            }

            if (!(initialIndex1 + 2 >= z.length)) {
              z[initialIndex1 + 2].display = true;
            }

            this.sectionList.forEach(element => {
              z.forEach(x => {
                if (element.QuickScanSectionId == x.QuickScanSectionId && x.display == true) {
                  element.display = true;
                }
              })
            })

          }

          this.spinner = false;

          let unanswerdQuestion = this.quickscans[0].QuickScanQuestions.filter(x => x.isPostCompleted == false && x.IsOptional == false && x.hidden == false);
          if (unanswerdQuestion.length == 0) {
            this.sectionList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0].completed = true;
          }else{
            this.sectionList.filter(x => x.QuickScanSectionId == this.quickscans[0].QuickScanSectionId)[0].completed = false;
          }

        } catch (error) {

          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      }
      this._commonService.dismiss();
      if (goBack) {
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        setTimeout(() => {
          this.goBack();
        }, 10);

      } else {
        //end quick scan
        if (this.sectionList.filter(x => x.optional != true)[this.stepper.selectedIndex].completed) {
          if (this.stepper.selectedIndex == (this.sectionList.filter(x => x.optional != true).length - 1)) {
            // this.endSectionValue = true;
            // this.endQuickScan();
          }

          if (!skipSection) {
            // setTimeout(() => {
            //   this.stepper.next();
            // }, 50);
            // this.buttonDisability = false;


          }



        }
      }

    } else {
      if (goBack) {
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        setTimeout(() => {
          this.goBack()
        }, 10);
        ;
      }
    }

    if(this.stepper.selectedIndex == 0){
      if(this.sectionList.length==1){
        this.endSectionValue = true;
      }else{
        this.endSectionValue = false;
      }
    }


  }

  async goToNextSection() {


    let finalIndex = this.selectedIndex + 1;
    this.updateStepper(finalIndex);

  }


  async updateStepper(finalIndex) {

    let nextStep = this.sectionList.filter(x => !x.optional && x.display)[finalIndex];
    this.sectionList.forEach(element => {
      element.display = false;
    });
    // this.sectionList.forEach(element => {
    //   if (element.completed == true) {
    //     element.optional = false;
    //   }
    // });
    this.sectionList[0].display = true;
    this.sectionList[this.sectionList.length - 1].display = true;

    let filteredSection = this.sectionList.filter(x => !x.optional);
    let nextIndex = filteredSection.findIndex((item, index) => item.QuickScanSectionId == nextStep.QuickScanSectionId);
    filteredSection[nextIndex].display = true;

    if(!(nextIndex+1>=filteredSection.length)) filteredSection[nextIndex + 1].display = true;
    if(!(nextIndex+2>=filteredSection.length)) filteredSection[nextIndex + 2].display = true;
    if (nextIndex >= 1 && filteredSection[nextIndex - 1]) filteredSection[nextIndex - 1].display = true;
    if (nextIndex < 1 && filteredSection[1 - nextIndex]) filteredSection[1 - nextIndex].display = true;
    if (nextIndex >= 2 && filteredSection[nextIndex - 2]) filteredSection[nextIndex - 2].display = true;
    if (nextIndex < 2 && filteredSection[2 - nextIndex]) filteredSection[2 - nextIndex].display = true;




    let visibleSection = this.sectionList.filter(x => x.optional != true && x.display);
    if (nextIndex + 1 == filteredSection.length) {
      this.endSectionValue = true
    } else {
      this.endSectionValue = false
    }
    let index = this.sectionList.filter(x => x.optional != true && x.display).findIndex((x, index) => x.QuickScanSectionId == filteredSection[nextIndex].QuickScanSectionId);
    await this.getQuickScanQuestions(visibleSection[index].QuickScanSectionId, false);


    if(this.endSectionValue==true){
      this.stepper.selectedIndex = index;
    }else{
      setTimeout(() => {

        this.stepper.selectedIndex = index;



      //this.stepper.next();
    },0);
    }



  }

  testingChanges(event) {
    setTimeout(() => {
      if (event.type == "click" && (event.target.classList[0] == "mat-step-label" || event.target.classList[0] == "mat-horizontal-stepper-header")) {

        this.updateStepper(this.selectedIndex);
      }
    }, 50);
  }

  async saveFollowUp(followUp, question) {
    question.showLoading = true;
    try {
      let data = {
        QuickScanQuestionId: followUp.QuickScanQuestionId ? followUp.QuickScanQuestionId : null,
        SelectedAnswerId: null,
        AnswerValue: followUp.AnswerValue ? followUp.AnswerValue : null
      }
      let res = await this._apiService.postFillQuickScan(data, sessionStorage.QuickScanFormId);
      question.showLoading = false;
      question.isPostCompleted = true;
    } catch (error) {
      question.showLoading = false;
    }

  }
  async deleteFollowUoQuickscanQuestion(followUp,question){
    try {
      let data = {
        QuickScanQuestionId: followUp.QuickScanQuestionId ? followUp.QuickScanQuestionId : null,
        SelectedAnswerId: null,
        AnswerValue: followUp.AnswerValue ? followUp.AnswerValue : null
      }
      let res = await this._apiService.postFillQuickScan(data, sessionStorage.QuickScanFormId);
    } catch (error) {
      console.log(error);
    }
  }

  followupChanged(question) {
    question.isPostCompleted = true;
  }

  async postFollowUpData(data, question) {
    try {
      let res = await this._apiService.postFillQuickScan(data, sessionStorage.QuickScanFormId);
      // question.showLoading = false;
      // sessionStorage.quickScanSection = JSON.stringify(this.quickscans);
    }
    catch (error) {
      // question.showLoading = false;
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

}
